import { ChatMascotLookPicker, DesktopMascotLooks } from './DesktopMascotLooks.js';
import { GyroSidePanel } from './GyroSidePanel.js';
import { HtmlPreviewBody, HtmlPreviewHeader } from './HtmlPreviewTab.js';
import { ClarificationCard } from './ClarificationCard.js';
import { ClientActionRunner, browserClientActionLedger, clientActionLedgerKey, clientActionRefusalMessage, clientExecutingFromInbox, clientExecutingFromResponse, clientExecutingRefusal, mountClientActionRunner } from './clientActions.js';
import { ComposerAddMenu } from './ComposerAddMenu.js';
import { ConversationContextMenu } from './ConversationContextMenu.js';
import { currentMcpStatus } from './desktopMcp.js';
import { createAutoSave } from './desktopAutoSave.js';
import { DesktopAccountMenu } from './DesktopAccountMenu.js';
import { DesktopCoworkBar } from './DesktopCoworkBar.js';
import { DesktopDropOverlay } from './DesktopDropOverlay.js';
import { DesktopKnowledgeBar } from './DesktopKnowledgeBar.js';
import { DesktopNotifications } from './DesktopNotifications.js';
import { DesktopSettings } from './DesktopSettings.js';
import { DesktopTaskPanel } from './DesktopTaskPanel.js';
import { DocumentOutputs } from './DocumentOutputs.js';
import { DESKTOP_DOCUMENT_CAPABILITIES, detectDocumentRequest, documentOutputContext, paneDocumentContext, resolveDocumentRequest, shouldOfferExport } from './documentRequests.js';
import { GeneratedFiles } from './GeneratedFiles.js';
import { LocalFileContinueCard } from './LocalFileContinueCard.js';
import { LOCAL_FILE_CONTINUATION_MESSAGE, LOCAL_FILE_EVIDENCE_UNREACHABLE, LOCAL_FILE_EVIDENCE_UNSUPPORTED, LocalFileContinuations, continuationMessage, evidenceRefusalText, localFileEvidence, localFileEvidenceService, localFileOriginalRequest, parseDesktopActionResult } from './localFileContinuation.js';
import { localActionFolders, localActionFoldersConfirmable } from './localFiles.js';
import { LocalFilesMenu } from './LocalFilesMenu.js';
import { parseHostNotification } from './notificationCenter.js';
import { ON_DEMAND_FILES, onDemand } from './onDemand.js';
import { StreamingActivity } from './StreamingActivity.js';
import { SupportCard } from './SupportCard.js';
import { useDesktopDrop } from './useDesktopDrop.js';
import { useDesktopMcp } from './useDesktopMcp.js';
import { useDesktopSkills } from './useDesktopSkills.js';
import { useMascotAnimations } from './useMascotAnimations.js';
import { useMascotShareHide } from './useMascotShareHide.js';
import { useNotificationCenter } from './useNotificationCenter.js';
import { PetsSidebar, PetsWorkspace, createActionReviewSession, createCheckStatusSessions, clearPetDecisionSession } from './companionParts.js';
import { clearNativePets } from './pets/native.js';
import { STARSCRIBE_SHELL } from './starscribe/shell.js';
import { AttentionBell, AttentionCenter, AttentionItemCard } from './attention/AttentionCenter.js';
/**
 * The document generator, loaded the first time a person makes a file (onDemand.ts); it loads only the writer that file's
 * format needs. In the vendored build it is gyro-react-documents.mjs, beside gyro-react.mjs.
 */
const loadGenerator = onDemand({
    file: ON_DEMAND_FILES.documents,
    what: 'the document generator',
    load: () => import('./documentGenerator.js'),
    check: (module) => typeof module.generateDocument === 'function',
});
const generateDocument = async (input) => (await loadGenerator()).generateDocument(input);
export const FULL_PARTS = {
    desktop: true,
    AttentionBell, AttentionCenter, AttentionItemCard,
    PetsSidebar, PetsWorkspace, clearNativePets, createActionReviewSession, createCheckStatusSessions, clearPetDecisionSession,
    DesktopSettings, DesktopAccountMenu, DesktopTaskPanel, LocalFilesMenu, ComposerAddMenu, DesktopCoworkBar, LocalFileContinueCard,
    ChatMascotLookPicker, DesktopMascotLooks, DesktopKnowledgeBar, DesktopDropOverlay, DesktopNotifications, StreamingActivity,
    useDesktopDrop, useDesktopMcp, useDesktopSkills, useMascotAnimations, useMascotShareHide, useNotificationCenter, parseHostNotification, currentMcpStatus,
    LocalFileContinuations, LOCAL_FILE_CONTINUATION_MESSAGE, LOCAL_FILE_EVIDENCE_UNREACHABLE, LOCAL_FILE_EVIDENCE_UNSUPPORTED, continuationMessage, evidenceRefusalText,
    localFileEvidence, localFileEvidenceService, localFileOriginalRequest, parseDesktopActionResult,
    localActionFolders, localActionFoldersConfirmable, createAutoSave,
    documents: true,
    DocumentOutputs, generateDocument, DESKTOP_DOCUMENT_CAPABILITIES, detectDocumentRequest, resolveDocumentRequest,
    documentOutputContext, paneDocumentContext, shouldOfferExport,
    paneHost: true,
    mountClientActionRunner,
    createClientActionRunner: (options) => new ClientActionRunner(options),
    browserClientActionLedger, clientActionLedgerKey, clientActionRefusalMessage, clientExecutingFromInbox, clientExecutingFromResponse,
    clientExecutingRefusal,
    ConversationContextMenu, ClarificationCard, SupportCard, GeneratedFiles, GyroSidePanel, HtmlPreviewHeader, HtmlPreviewBody,
    starscribe: STARSCRIBE_SHELL,
};
//# sourceMappingURL=fullParts.js.map